import { render, staticRenderFns } from "./DialogAddStudent.vue?vue&type=template&id=9ba50aca&"
import script from "./DialogAddStudent.vue?vue&type=script&lang=js&"
export * from "./DialogAddStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports